/** Local notification preferences. Room overrides are client-local by design; Matrix push rules remain authoritative for server notify semantics. */
const KEY = "alg.notif.settings.v2";
export type RoomNotifyMode = "all" | "mentions" | "mute";
export type SoundId = "soft" | "double" | "chime";
export interface RoomNotificationSetting { mode: RoomNotifyMode; sound?: SoundId; }
export interface NotificationCategories {
  directMessages: boolean;
  groupMessages: boolean;
  mentions: boolean;
  replies: boolean;
  reactions: boolean;
  invites: boolean;
  incomingCalls: boolean;
}
export interface NotificationSettings {
  enabled: boolean;
  sound: boolean;
  callSound: boolean;
  messageSound: SoundId;
  callTone: SoundId;
  categories: NotificationCategories;
  rooms: Record<string, RoomNotificationSetting>;
}
const defaultCategories: NotificationCategories = {
  directMessages: true,
  groupMessages: true,
  mentions: true,
  replies: true,
  reactions: true,
  invites: true,
  incomingCalls: true,
};
const defaults: NotificationSettings = { enabled: true, sound: true, callSound: true, messageSound: "soft", callTone: "double", categories: defaultCategories, rooms: {} };
function read(): Partial<NotificationSettings> {
  try { const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) as Partial<NotificationSettings> : {}; } catch { return {}; }
}
export function loadNotificationSettings(): NotificationSettings {
  const old = read();
  const oldCategories = old.categories && typeof old.categories === "object" ? old.categories : {};
  return {
    ...defaults,
    ...old,
    categories: { ...defaultCategories, ...oldCategories },
    rooms: old.rooms && typeof old.rooms === "object" ? old.rooms : {},
  };
}
export function saveNotificationSettings(next: NotificationSettings): void { try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* private mode */ } }
export function roomNotificationSetting(roomId: string): RoomNotificationSetting | undefined { return loadNotificationSettings().rooms[roomId]; }
export function saveRoomNotificationSetting(roomId: string, setting: RoomNotificationSetting | null): void {
  const next = loadNotificationSettings();
  if (setting) next.rooms[roomId] = setting; else delete next.rooms[roomId];
  saveNotificationSettings(next);
}
export const SOUND_OPTIONS: ReadonlyArray<{ id: SoundId; label: string }> = [
  { id: "soft", label: "Soft" }, { id: "double", label: "Double tone" }, { id: "chime", label: "Chime" },
];
